import Phaser from 'phaser';

/**
 * Helpers de transição entre cenas.
 *
 * Centralizam o "fade in/out" para que nenhum scene.start aconteça de
 * forma abrupta, e qualquer ajuste de duração/curva fique num ponto só.
 *
 * Política:
 *  - `fadeInScene` no início de `create()` faz a cena aparecer suave.
 *  - `fadeToScene` é o substituto de `this.scene.start(...)` quando se
 *    quer transicionar com fade out + nova cena.
 */

const DEFAULT_FADE_IN_MS = 220;
const DEFAULT_FADE_OUT_MS = 220;

export function fadeInScene(scene: Phaser.Scene, durationMs: number = DEFAULT_FADE_IN_MS): void {
  scene.cameras.main.fadeIn(durationMs, 0, 0, 0);
}

/**
 * Transiciona para outra cena com fade out na atual.
 *
 * `data` é encaminhado para a próxima cena via `init(data)` — mesma
 * convenção do `scene.start`. A nova cena deve chamar `fadeInScene`
 * dentro de seu próprio `create()`.
 */
export function fadeToScene(
  scene: Phaser.Scene,
  key: string,
  data?: object,
  durationMs: number = DEFAULT_FADE_OUT_MS,
): void {
  const cam = scene.cameras.main;
  // Evita empilhar fadeOuts duplicados, mas NÃO bloqueia se houver um
  // fadeIn ainda em andamento — caso contrário, transições disparadas logo
  // após o fadeIn da cena nunca acontecem (em Phaser 4, fadeEffect é
  // compartilhado: direction=true é fadeOut, direction=false é fadeIn).
  if (cam.fadeEffect.isRunning && cam.fadeEffect.direction === true) return;
  cam.fadeOut(durationMs, 0, 0, 0);
  cam.once(Phaser.Cameras.Scene2D.Events.FADE_OUT_COMPLETE, () => {
    scene.scene.start(key, data);
  });
}
